// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Y3QV","title":"Header_title__QZlJw","side":"Header_side__7JmrE"};